import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageContextService } from '../../../context/storage-context/storage-context.service';
import { CookieService } from '../../services/cookies/cookie.service';
import { GoogleAnalyticsService } from '../../services/google-analytics/google-analytics.service';
import { AppConfiguration } from '../../services/configuration/app.configuration';
import { buildStretchitHeaders } from './request-headers';

export const stretchitApiHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageContextService);
  const cookies = inject(CookieService);
  const googleAnalytics = inject(GoogleAnalyticsService);
  const headers = buildStretchitHeaders(req, {
    cookies,
    googleAnalytics,
    storage,
    config: inject(AppConfiguration),
  });

  return next(req.clone({ headers }));
};
